import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import NoticiasUsuario from "./usuario/NoticiasUsuario";

export default function IntranetUsuarioNoticiasPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialItem = location.state?.initialItem;

  return (
    <div className="intranet-red-theme">
      <NoticiasUsuario
        onVolver={() => navigate("/menu/intranet/usuario")}
        initialItem={initialItem}
      />
    </div>
  );
}
